import ApiService from '@/common/api.service'

const PointService = {
  getBankAccount (params) {
    return ApiService.query('bank-account', params)
  },
  getProductList (params) {
    return ApiService.query('products', params)
  },
  getProduct (paymentWay, params) {
    return ApiService.query(`products/${paymentWay}`, params)
  },
  getPriceList (paymentWay, params) {
    return ApiService.query(`products/${paymentWay}/prices`, params)
  },
  getOrder (params) {
    return ApiService.post('purchase/orders', params)
  },
  getBitcashPrepare (id, params) {
    return ApiService.post(`purchase/orders/${id}/bitcash/prepare`, params)
  },
  getNetridecashPrepare (id, params) {
    return ApiService.post(`purchase/orders/${id}/netridecash/prepare`, params)
  },
  getOrderComplete (id, paymentWay, params) {
    return ApiService.query(`purchase/orders/${id}/${paymentWay}/complete`, params)
  }
}
export default PointService
